import { Controller } from "@hotwired/stimulus"

// Experience-section header: shows the average per-entry content score (live)
// and collapses/expands the entry list. Recomputes from every entry's stored
// analysis when a content-analyzer fires "content-analyzer:scored".
export default class extends Controller {
  static targets = ["arc", "value", "label", "caret", "count"]

  connect() {
    this.C = 125.66
    this._onScored = () => this.recompute()
    document.addEventListener("content-analyzer:scored", this._onScored)
    this.recompute()
  }

  disconnect() {
    document.removeEventListener("content-analyzer:scored", this._onScored)
  }

  toggle() {
    const list = this._list()
    if (!list) return
    const collapsed = list.style.display === "none"
    list.style.display = collapsed ? "" : "none"
    if (this.hasCaretTarget) this.caretTarget.textContent = collapsed ? "expand_less" : "expand_more"
  }

  recompute() {
    const scores = []
    this._section().querySelectorAll('[data-content-analyzer-target="store"]').forEach((el) => {
      try {
        const a = JSON.parse(el.value || "{}")
        if (a && a.fingerprint && a.score !== undefined && a.score !== null) {
          scores.push(Math.max(0, Math.min(100, parseInt(a.score, 10) || 0)))
        }
      } catch (e) { /* ignore malformed */ }
    })
    if (!scores.length) return this._paint(null)
    this._paint(Math.round(scores.reduce((x, y) => x + y, 0) / scores.length))
  }

  _section() { return this.element.closest("[data-resume-module-editor]") || document }
  _list() { return this._section().querySelector("[data-resume-items]") }

  _paint(score) {
    const has = score !== null
    const s = has ? score : 0
    const band = s >= 80 ? "#14b8a6" : (s >= 50 ? "#f59e0b" : "#ef4444")
    if (this.hasArcTarget) {
      this.arcTarget.setAttribute("stroke", has ? band : "#e5e7eb")
      this.arcTarget.setAttribute("stroke-dashoffset", has ? (this.C * (1 - s / 100)).toFixed(2) : this.C)
    }
    if (this.hasValueTarget) this.valueTarget.textContent = has ? String(s) : "—"
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = has
        ? `${s >= 80 ? "Strong" : s >= 50 ? "Good" : "Needs work"} — Experience content score`
        : "Analyze your entries to see a score"
    }
  }
}
